module.exports = __webpack_public_path__ + "img/sharepaylink.a88964c1.svg";